var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToYahoo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.86883H6.0051L8.33726 13.2605L10.6997 6.86883H14.5989L8.72745 22H4.8029L6.41024 17.9905L2.00012 6.86883H2ZM19.1396 11.976H14.7723L18.6485 2L23 2.0002L19.1396 11.976ZM15.9163 12.9307C17.2563 12.9307 18.3426 14.0945 18.3426 15.5298C18.3426 16.9652 17.2563 18.1289 15.9163 18.1289C14.5764 18.1289 13.4904 16.9652 13.4904 15.5298C13.4904 14.0945 14.5766 12.9307 15.9163 12.9307Z",
    fill: "#5F01D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToYahoo);
export default __webpack_public_path__ + "static/media/toYahoo.97ef99b442f692317c064a9ba19e5dd7.svg";
export { ForwardRef as ReactComponent };